var _path, _path2, _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcActiveAward(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1236_4602)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 7C2 3.68629 4.68629 1 8 1H36C39.3137 1 42 3.68629 42 7V35C42 38.3137 39.3137 41 36 41H8C4.68629 41 2 38.3137 2 35V7Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 1.5H36C39.0376 1.5 41.5 3.96243 41.5 7V35C41.5 38.0376 39.0376 40.5 36 40.5H8C4.96243 40.5 2.5 38.0376 2.5 35V7C2.5 3.96243 4.96243 1.5 8 1.5Z",
    stroke: "#E5E7EB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1236_4602",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 13,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 13,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1236_4602)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.0635 14.0012H18.9385C18.2139 14.0012 17.6232 14.5973 17.6506 15.3192C17.6561 15.4641 17.6615 15.609 17.6697 15.7512H14.7822C14.4186 15.7512 14.126 16.0438 14.126 16.4075C14.126 18.9395 15.042 20.7004 16.2725 21.8954C17.4838 23.0739 18.9604 23.6672 20.0486 23.968C20.6885 24.1458 21.126 24.679 21.126 25.2149C21.126 25.7864 20.6611 26.2512 20.0896 26.2512H19.376C18.892 26.2512 18.501 26.6422 18.501 27.1262C18.501 27.6102 18.892 28.0012 19.376 28.0012H24.626C25.11 28.0012 25.501 27.6102 25.501 27.1262C25.501 26.6422 25.11 26.2512 24.626 26.2512H23.9123C23.3408 26.2512 22.876 25.7864 22.876 25.2149C22.876 24.679 23.3107 24.143 23.9533 23.968C25.0443 23.6672 26.5209 23.0739 27.7322 21.8954C28.96 20.7004 29.876 18.9395 29.876 16.4075C29.876 16.0438 29.5834 15.7512 29.2197 15.7512H26.3322C26.3404 15.609 26.3459 15.4668 26.3514 15.3192C26.3787 14.5973 25.7881 14.0012 25.0635 14.0012ZM15.4631 17.0637H17.7709C18.0197 19.5274 18.5693 21.1735 19.19 22.2754C18.5092 21.9747 17.801 21.5508 17.1885 20.9547C16.3135 20.1043 15.6025 18.8766 15.4658 17.0637H15.4631ZM26.8162 20.9547C26.2037 21.5508 25.4955 21.9747 24.8146 22.2754C25.4354 21.1735 25.985 19.5274 26.2338 17.0637H28.5416C28.4021 18.8766 27.6912 20.1043 26.8189 20.9547H26.8162Z",
    fill: "#092E5E"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1236_4602",
    x: 0,
    y: 0,
    width: 44,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1236_4602"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1236_4602",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActiveAward);
export default __webpack_public_path__ + "static/media/ic_active_award.a23878df38bbb1f74689046930b0c31b.svg";
export { ForwardRef as ReactComponent };